// 利用a标签下载
export function downloadFileByUrl(url){
    const elink = document.createElement('a')
    elink.href = url
    document.body.appendChild(elink)
    elink.click()
    document.body.removeChild(elink);
}
